<script setup lang="ts">
import {onMounted, ref} from "vue";
import SubscriptionService from "@/ts/User/Service/SubscriptionService";
import FullPopup from "@/components/UI/Pupup/FullPopup.vue";
import AboutSubscriptionBlock from "@/components/User/Settings/Popup/AboutSubscription/AboutSubscriptionBlock.vue";
import CheckItem from "@/components/User/Settings/Popup/AboutSubscription/CheckItem.vue";
import UserService from "@/ts/User/Service/UserService";
import UserSubscription from "@/ts/User/Types/UserSubscription";
import AuthService from "@/ts/User/Service/AuthService";
import {useRouter} from "vue-router";


const show = ref(false)
const cancelRecurrentLink = ref<string>( )
const subscription = ref<UserSubscription>()

const initCancelRecurrentLink = async () => {
  const url = new URL('https://sbsite.pro/stop_subs_1');
  const userId = await AuthService.getUserId();
  const profile = await UserService.getProfile();
  url.searchParams.append('email', profile.email);
  url.searchParams.append('id_pril', userId)
  cancelRecurrentLink.value = url.href;
}

onMounted(() => {
  const subscriptionService = SubscriptionService.getInstance()
  subscriptionService.addEventListener('showAbout', async () => {
    show.value = true
    subscription.value = await UserService.getSubscription()
    await initCancelRecurrentLink();
  })
})
const router = useRouter();
const openSupportChat = () => {
  window.open('https://online.muradyangames.com/tlgrm','_blank')
}
</script>

<template>
  <FullPopup v-model:show="show" theme="light" closed :padding="false" ref="popup">
    <div class="subscription-container">
      <div class="subscription-container__preview">
        <div class="subscription-container__preview__about">О подписке</div>
      </div>
      <div class="subscription-container__form" v-if="subscription">
        <AboutSubscriptionBlock :is-recurrent="subscription.isRecurrent" :price="subscription.price"
                                @support="openSupportChat"
                                :duration="subscription.durationInMonths"
                                :expired-date="new Date(subscription.datePayment)"
                                :card="subscription.cardLastFour"/>
        <a :href="cancelRecurrentLink" target="_blank" class="cancel-recurrent" v-if="subscription.isRecurrent">
          Отменить автоматическое продление
        </a>
      </div>
      <div class="subscription-container__content">
        <div class="subscription-container__content__chapter">
          <div class="subscription-container__content__title">С подпиской PRO вы получаете полный доступ к уникальным
            инструментам для личностного роста и гармонизации жизни:
          </div>
          <div class="subscription-container__content__items">
            <CheckItem> Новые медитации месяца уровня PRO</CheckItem>
            <CheckItem> 10 гениальных дневников для саморефлексии, работы с целями и желаниями и другими аспектами
              жизни
            </CheckItem>
            <CheckItem> Полная версия книги «Игра Атлантов. Алхимия мечты»</CheckItem>
            <CheckItem> 4 колоды метафорических карт, которые помогут найти ответы на все вопросы</CheckItem>
            <CheckItem> 4 колоды метафорических карт, которые помогут найти ответы на все вопросы</CheckItem>
          </div>
        </div>
      </div>
    </div>
  </FullPopup>
</template>

<style scoped lang="scss">
.cancel-recurrent {
  color: #9A9B9C;
  text-decoration: underline;
  font-size: 12px;
  height: 30px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.subscription-container {
  padding: 34px 20px 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;

  &__preview {
    color: #9A9B9C;
    font-size: 14px;
    height: 40px;
  }

  &__form {
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding-bottom: 30px;
    border-bottom: 1px solid #B7B7B8;
  }

  &__content {
    color: #363739;
    display: flex;
    flex-direction: column;
    gap: 40px;

    &__chapter {
      display: flex;
      flex-direction: column;
      gap: 20px;
    }

    &__title {
      font-weight: 500;
      font-size: 14px;

    }

    &__items {
      display: flex;
      flex-direction: column;
      gap: 10px;
    }
  }
}

:deep(.popup.light) {
  background-color: #F5F5F5;
}
</style>
